import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bet-loader',
  templateUrl: './bet-loader.component.html',
  styleUrls: ['./bet-loader.component.scss'],
})
export class BetLoaderComponent implements OnInit {
  title = 'app-bet-loader';

  ngOnInit(): void {}
}
